import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import React from 'react';
import { isNumber } from '@jd/jmtd-tools/es/is';
import ConfigConsumer from '../ConfigConsumer';
import { isEmpty } from '../tools/util';
export default function Space(_ref) {
  var className = _ref.className,
      size = _ref.size,
      children = _ref.children,
      vertical = _ref.vertical,
      align = _ref.align,
      wrap = _ref.wrap,
      style = _ref.style;
  var length = React.Children.count(children);
  return /*#__PURE__*/React.createElement(ConfigConsumer, {
    size: size
  }, function (_ref2) {
    var configSize = _ref2.size;
    return /*#__PURE__*/React.createElement("div", {
      className: classNames('jmtd-space', className, {
        'jmtd-space-large': configSize === 'large',
        'jmtd-space-small': configSize === 'mini' || configSize === 'small',
        'jmtd-space-vertical': vertical,
        'jmtd-space-horizontal': !vertical,
        'jmtd-space-wrap': wrap
      }),
      style: _objectSpread({
        alignItems: align
      }, style)
    }, React.Children.toArray(children).filter(function (n) {
      return !isEmpty(n);
    }).map(function (child, index) {
      var itemStyle = {};

      if (isNumber(size) && index !== length - 1) {
        itemStyle["margin".concat(vertical ? 'Bottom' : 'Right')] = size;
      }

      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: classNames('jmtd-space-item', {
          'jmtd-space-item-vertical': vertical,
          'jmtd-space-item-horizontal': !vertical
        }),
        style: itemStyle
      }, child);
    }));
  });
}
Space.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.oneOf(['mini', 'small', 'middle', 'large']), PropTypes.number]),
  align: PropTypes.string,
  vertical: PropTypes.bool,
  wrap: PropTypes.bool,
  style: PropTypes.object
};
Space.defaultProps = {
  children: null,
  size: null,
  className: '',
  align: null,
  vertical: false,
  wrap: false,
  style: null
};